import { PubSubSharedActions } from "./pubsub-actions.ts";

interface LogoutMessageLogout {
  logout?: boolean;
}

interface LogoutMessageReload {
  reload?: boolean;
}

export type LogoutMessage = LogoutMessageLogout & LogoutMessageReload;
export let broadcast_logout: BroadcastChannel | null = new BroadcastChannel(PubSubSharedActions.LOGOUT);

export function open() {
  if (broadcast_logout == null) {
    broadcast_logout = new BroadcastChannel(PubSubSharedActions.LOGOUT);
  }
}

export function close() {
  if (broadcast_logout != null) {
    broadcast_logout.close();
    broadcast_logout = null;
  }
}

export function broadcastLogout(message: LogoutMessage) {
  if (broadcast_logout != null) {
    broadcast_logout.postMessage(message);
  }
}
